import { ElementRef } from '@angular/core';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/forms";
function RiskInfoCheckboxesComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.showHoldings, $event) || (ctx_r1.showHoldings = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeShowHoldings($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 2);
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4, "Show Holdings");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.showHoldings);
} }
function RiskInfoCheckboxesComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.showComparables, $event) || (ctx_r1.showComparables = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeShowComparables($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 2);
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4, "Show Comparables");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.showComparables);
} }
function RiskInfoCheckboxesComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
    i0.ɵɵtwoWayListener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_2_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.showBenchmark, $event) || (ctx_r1.showBenchmark = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function RiskInfoCheckboxesComponent_Conditional_2_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeShowBenchmark($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 2);
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4, "Show Benchmark");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.showBenchmark);
} }
export class RiskInfoCheckboxesComponent {
    constructor(accountsService, eltRef) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.showBenchmark = this.eltRef.nativeElement.getAttribute('riskShowBenchmark') === 'true';
        this.showComparables = this.eltRef.nativeElement.getAttribute('riskShowComparables') === 'true';
        this.showHoldings = this.eltRef.nativeElement.getAttribute('riskShowHoldings') === 'true';
        this.isModelPortfolio = this.eltRef.nativeElement.getAttribute('isModelPortfolio') === 'true';
        this.benchmarkDisabled = JSON.parse(this.eltRef.nativeElement.getAttribute('benchmarkDisabled'));
        if (this.benchmarkDisabled)
            this.showBenchmark = false;
    }
    changeShowHoldings(showHoldings) {
        this.accountsService.putUserPreferences({ risk_show_holdings: showHoldings }).subscribe({
            next: () => window.location.reload(),
            error: () => { },
        });
    }
    changeShowComparables(showComparables) {
        this.accountsService.putUserPreferences({ risk_show_comparables: showComparables }).subscribe({
            next: () => window.location.reload(),
            error: () => { },
        });
    }
    changeShowBenchmark(showBenchmark) {
        this.accountsService.putUserPreferences({ risk_show_benchmark: showBenchmark }).subscribe({
            next: () => window.location.reload(),
            error: () => { },
        });
    }
}
RiskInfoCheckboxesComponent.ɵfac = function RiskInfoCheckboxesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskInfoCheckboxesComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
RiskInfoCheckboxesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiskInfoCheckboxesComponent, selectors: [["ycn-risk-info-checkboxes"]], standalone: false, decls: 3, vars: 2, consts: [[1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function RiskInfoCheckboxesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, RiskInfoCheckboxesComponent_Conditional_0_Template, 5, 1, "label", 0)(1, RiskInfoCheckboxesComponent_Conditional_1_Template, 5, 1, "label", 0);
        i0.ɵɵconditionalCreate(2, RiskInfoCheckboxesComponent_Conditional_2_Template, 5, 1, "label", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.isModelPortfolio ? 0 : 1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.benchmarkDisabled ? 2 : -1);
    } }, dependencies: [i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgModel], encapsulation: 2 });
